export enum EAnalyticsEvent {
  GetHelpButtonClick = 'get_help_button_click',
  BookHealthCoachClick = 'book_health_coach_click',
  TakeSpotlightTour = 'take_spotlight_tour'
};